module.exports = __webpack_public_path__ + "static/ABCFavorit-Regular-5b9eb6c0448fd8fe8ad2c30483523213.woff2";